export default {
      id: "quotes-usage",
      viewBox: "0 0 53 36",
      url: __webpack_public_path__ + "sprite.svg#quotes",
      toString: function () {
        return this.url;
      }
    }